import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";
import logo from "../assets/krs-logo-transparent.png";
import kwLogo from "../assets/kw-realty-logo.png";
import { NAV_LINKS } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-navy text-cream">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <img src={logo} alt="KRS Design and Renovation" className="w-56 mb-6" />
            <p className="font-sans text-sm leading-relaxed text-cream/70 max-w-xs">
              Kitchen &amp; bathroom renovations, whole-home remodels, and interior design — real estate, design, and renovation under one experienced team serving Greater Birmingham, Alabama.
            </p>
            <p className="font-sans text-[11px] tracking-luxe uppercase text-gold mt-4">Licensed &amp; Insured • Free Consultations</p>
            <div className="flex gap-4 mt-6">
              <a href="https://www.instagram.com/richselsor_kw_hoover_realtor" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-cream/20 flex items-center justify-center hover:bg-gold hover:text-navy hover:border-gold transition-colors duration-300"><Instagram size={18} strokeWidth={1.5} /></a>
              <a href="https://www.facebook.com/profile.php?id=61558283004439" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-cream/20 flex items-center justify-center hover:bg-gold hover:text-navy hover:border-gold transition-colors duration-300"><Facebook size={18} strokeWidth={1.5} /></a>
            </div>
          </div>

          <div className="md:col-span-3 md:col-start-6">
            <h4 className="font-sans text-[11px] tracking-luxe uppercase text-gold mb-6">Explore</h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="font-sans text-sm text-cream/75 hover:text-gold-soft transition-colors duration-300">{l.label}</Link>
                </li>
              ))}
              <li><Link to="/faq" className="font-sans text-sm text-cream/75 hover:text-gold-soft transition-colors duration-300">FAQs</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-sans text-[11px] tracking-luxe uppercase text-gold mb-6">Get in Touch</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-cream/75"><Phone size={16} strokeWidth={1.5} className="mt-0.5 text-gold" /><a href="tel:+16154972166" className="font-sans text-sm hover:text-gold-soft transition-colors duration-300">615-497-2166</a></li>
              <li className="flex items-start gap-3 text-cream/75"><Mail size={16} strokeWidth={1.5} className="mt-0.5 text-gold" /><a href="mailto:rselsor56@gmail.com" className="font-sans text-sm hover:text-gold-soft transition-colors duration-300">rselsor56@gmail.com</a></li>
              <li className="flex items-start gap-3 text-cream/75"><MapPin size={16} strokeWidth={1.5} className="mt-0.5 text-gold" /><span className="font-sans text-sm">Studio by appointment</span></li>
            </ul>
            <Link to="/contact" className="inline-block mt-6 px-6 py-3 bg-gold text-navy font-sans text-[11px] tracking-wide-nav uppercase hover:bg-cream transition-colors duration-300">Start Your Project</Link>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-cream/12 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex flex-col md:flex-row items-center gap-4 text-center md:text-left">
            <span data-testid="footer-kw-logo-badge" className="bg-white px-3 py-1.5 inline-flex items-center">
              <img src={kwLogo} alt="KW Realty Group" className="h-7 w-auto" />
            </span>
            <div data-testid="footer-agent-license" className="font-sans text-xs tracking-wide text-cream/70 leading-snug">
              <p className="text-cream">Richard Selsor</p>
              <p>Lic# 000159320</p>
            </div>
            <p className="font-sans text-xs tracking-wide text-cream/50 md:border-l md:border-cream/20 md:pl-4">© {new Date().getFullYear()} KRS Design and Renovation. Licensed &amp; Insured.</p>
          </div>
          <p className="font-sans text-xs tracking-wide text-cream/50">Serving Birmingham, Hoover, Vestavia, Cahaba Heights &amp; Mountain Brook, AL</p>
        </div>
      </div>
    </footer>
  );
}
